// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { differenceInMinutes as fn } from "../differenceInMinutes.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const differenceInMinutes = convertToFP(fn, 2);

// Fallback for modularized imports:
export default differenceInMinutes;
